import React from 'react';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  totalCount,
  pageSize,
  onPageChange, 
  onPageSizeChange,
  pageSizeOptions = [5, 10, 20, 50, 100]
}) => {
  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const maxButtons = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxButtons - 1);
    
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(1, endPage - maxButtons + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  if (totalPages <= 0) return null;

  return (
    <div className="admin-pagination-container">
      <div className="admin-pagination-wrapper">
        {/* Records per page selector */}
        <div className="admin-page-size-selector">
          <label className="admin-page-size-label">
            Show:
            <select 
              value={pageSize} 
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              className="admin-page-size-select"
            >
              {pageSizeOptions.map(size => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            entries
          </label>
        </div>

        {/* Pagination buttons */}
        <div className="admin-pagination-buttons">
          {/* First Page */}
          <button
            className="admin-pagination-btn admin-pagination-first"
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            title="First Page"
          >
            ««
          </button>

          {/* Previous Page */}
          <button
            className="admin-pagination-btn admin-pagination-prev"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            title="Previous Page"
          >
            « Previous
          </button>

          {/* Page Numbers */}
          {getPageNumbers().map(pageNum => (
            <button
              key={pageNum}
              className={`admin-pagination-btn admin-pagination-number ${currentPage === pageNum ? 'active' : ''}`}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          ))}

          {/* Next Page */}
          <button
            className="admin-pagination-btn admin-pagination-next"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            title="Next Page"
          >
            Next »
          </button>

          {/* Last Page */}
          <button
            className="admin-pagination-btn admin-pagination-last"
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            title="Last Page"
          >
            »»
          </button>
        </div>
      </div>

      {/* Info section */}
      <div className="admin-pagination-info">
        Showing {(currentPage - 1) * pageSize + 1} to{' '}
        {Math.min(currentPage * pageSize, totalCount)} of {totalCount} entries
      </div>
    </div>
  );
};

export default Pagination;